import { render } from "./ProcessVariantsDrawerPanel.vue?vue&type=template&id=ebcd25da"
import script from "./ProcessVariantsDrawerPanel.vue?vue&type=script&lang=js"
export * from "./ProcessVariantsDrawerPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__